import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { noSearchResultsMessageVisable } from '../modules/actions';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [noSearchResultsMessageVisable.type]: (state) => {
    sendGAEvent({
      event: 'custom_event',
      event_category: 'Search page',
      event_action: 'zero search results',
      event_label: state.products.searchTerm,
    });
  },
};
